import { render, staticRenderFns } from "./WebsiteHeader.vue?vue&type=template&id=70c66c4c"
import script from "./WebsiteHeader.vue?vue&type=script&lang=ts"
export * from "./WebsiteHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports